import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const ShowMore = ({ title, url, className, type }) => (
	<a
		className={cx(
			styles.showMore,
			type && styles.keepRatio,
			styles[type],
			className
		)}
		href={url}
	>
		<div className={styles.area}>
			<div className={styles.figure}>
				<Icon icon="arrow-top" className={styles.icon} />
			</div>
			<div className={styles.title}>{title}</div>
		</div>
	</a>
);

ShowMore.propTypes = {
	title: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
	className: PropTypes.string,
	type: PropTypes.oneOf(['cardLandscape', 'cardPortrait'])
};

export default ShowMore;
